// extracted by mini-css-extract-plugin
export default {"subtitle-icon":"R26g9O","subtitleIcon":"R26g9O"};